import { BasicRoute, BasicRouteProps } from './BasicRoute';

import { StorageManager } from '@speeki/storage-manager';

import { GetTenantByNameDocument } from '@graphql/generated/graphql';

import { useQueryParam } from '@utils/hooks/useQueryParam';

import { APIService } from '@services/ApiService';
import { getPath } from '@services/RouteService/paths';

import { useQuery } from '@apollo/client';

interface ParamsRouteProps
    extends Omit<BasicRouteProps, 'condition' | 'loading' | 'redirectTo'> {
    additionalCondition?: boolean;
    redirectTo?: BasicRouteProps['redirectTo'];
}

export const ParamsRoute = ({
    additionalCondition,
    children,
    onRedirect,
    redirectTo,
    users,
}: ParamsRouteProps) => {
    const companyCode = useQueryParam('companySlug');

    const { data, loading } = useQuery(GetTenantByNameDocument, {
        context: {
            globalUrl: true,
        },
        fetchPolicy: 'network-only',
        notifyOnNetworkStatusChange: true,
        onCompleted: (payload) => {
            StorageManager.setValue('tenantUuid', payload?.tenant?.[0]?.uuid);
            new APIService().setGraphAPI = payload?.tenant?.[0]?.apiUrl;
        },
        skip: !companyCode,
        variables: {
            inputFilters: {
                tenantCount: 1,
                tenantName: companyCode,
            },
        },
    });

    const hasId = !!data?.tenant?.[0]?.uuid;
    const condition =
        (typeof additionalCondition == 'boolean'
            ? hasId && additionalCondition
            : hasId) || !loading;

    return (
        <BasicRoute
            condition={condition}
            loading={loading}
            onRedirect={onRedirect}
            redirectTo={redirectTo ?? getPath({ path: '/auth/welcome' })}
            users={users}
        >
            {children}
        </BasicRoute>
    );
};
